import React, { useEffect, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import SubHeader from '../../components/SubHeader';
import { hideLoading, showLoading } from '../../actions/loaderAction';
import { capitalizeWords } from '@/utils/common';
import { useAuth } from '../../AuthProvider';
import veryfied from "../../images/veryfied_sticker.svg";
import NotVeryfiedots from "../../images/notveryfive_dots.svg";
import { getMockInquiry } from '../../actions/inquiryAction';
import { isEmpty, trim } from 'lodash';
import { privateRoutePaths } from '@/routes/private.route.config';
import roles from '@/constant/roles.config';

function MockInquiryView(props) {
    const { id } = useParams();
    const [inqData, setInquiryData] = useState([]);
    const { isSuperAdmin, user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isAdmin } = useAuth();

    const getPrefix = () => {
        if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
        if (user && isDemoUser) return roles.DEMO.prefix;
        if (user && isEndUser) return roles.END_USER.prefix;
        if (user && isViewer) return roles.VIEWER.prefix;
        return roles.SUPER_ADMIN.prefix;
    };

    const mockInquiry = async (id) => {
        await props.getMockInq(id).then((response) => {
            if (response) {
                if (response.status === true) {
                    setInquiryData(response.data);
                }
            }
        }).catch((err) => {
            console.log("Error ==== ", err);
        });
    }
    useEffect(() => {
        if (id) {
            const fetchData = async () => {
                await mockInquiry(id);
            };
            fetchData();
        }
    }, [id]);

    return (
        <div className='company-main'>
            {(isSuperAdmin || isAdmin) && <SubHeader layer1="Mock Inquiry" layer2="View" layer3="" pageName="Mock Inquiry View" subTitle=""
                clickable={{
                    layer1: `/${getPrefix()}${privateRoutePaths.MOCK_INQUIRIES.path}`,
                    layer2: "",
                    layer3: ""
                }}
            />}

            <div className='company-info-details new-design'>
                <div className='row'>
                    <div className='col-xxl-4 col-xl-4 col-lg-4'>
                        <div className='card mb-3'>
                            <div className='company-card company-card-info'>
                                <div className='naming-wrape'>
                                    <div className='naming-pad'>
                                        <h3>From</h3>
                                    </div>
                                    <h6><img src={veryfied} alt="" /> Verified</h6>
                                </div>
                                <div className='middle-wrape'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <p>
                                                <span>Company Name</span>
                                                {!isEmpty(inqData.company_name) ? capitalizeWords(inqData.company_name) : ' - '}
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Contact Person</span>
                                                {!isEmpty(inqData.contact_person) ? capitalizeWords(inqData.contact_person) : ' - '}
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Email</span>
                                                {!isEmpty(inqData.email) ? inqData.email : ' - '}
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Phone</span>
                                                {!isEmpty(inqData.phone) ? inqData.phone : ' - '}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* To Section */}
                        <div className='card'>
                            <div className='company-card company-card-info'>
                                <div className='naming-wrape'>
                                    <div className='naming-pad'>
                                        <h3>To</h3>
                                    </div>
                                    {
                                        !isEmpty(trim(inqData.assignedmembers)) ? inqData.assignedmembers[0].assign_tomembers.status === 2 ? (
                                            <h6>
                                                <img src={veryfied} alt="" />
                                                <span> Verified</span>
                                            </h6>
                                        ) : (
                                            <h6>
                                                <img src={NotVeryfiedots} alt="" />
                                                <span style={{ color: "red" }}> Unverified</span>
                                            </h6>
                                        )
                                            : ''
                                    }
                                    {/* {!isEmpty(trim(inqData.assigned_to_member?.status)) ?
                                        trim(inqData.assigned_to_member?.status) == 1 ? (
                                            <h6>
                                                <img src={veryfied} alt="" />
                                                <span> Verified</span>
                                            </h6>
                                        ) : (
                                            <h6>
                                                <img src={NotVeryfiedots} alt="" />
                                                <span style={{ color: "red" }}> Unverified</span>
                                            </h6>
                                        )
                                        : ''} */}
                                </div>
                                <div className='middle-wrape'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <p>
                                                <span>Company Name</span>
                                                {!isEmpty(inqData.assignedmembers) ? capitalizeWords(inqData.assignedmembers[0].assign_tomembers?.company_name) : ' - '}
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Contact Person</span>
                                                {
                                                    (!isEmpty(inqData.assignedmembers) && (!isEmpty(inqData.assignedmembers[0].assign_tomembers?.salutation) ||
                                                        !isEmpty(inqData.assignedmembers[0].assign_tomembers?.first_name) ||
                                                        !isEmpty(inqData.assignedmembers[0].assign_tomembers?.last_name)))
                                                        ? `${inqData.assignedmembers[0].assign_tomembers?.salutation ?? ""} ${capitalizeWords(inqData.assignedmembers[0].assign_tomembers?.first_name ?? "")} ${capitalizeWords(inqData.assignedmembers[0].assign_tomembers?.last_name ?? "")}`
                                                        : "-"
                                                }
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Email</span>
                                                {!isEmpty(inqData.assignedmembers) && !isEmpty(inqData.assignedmembers[0].assign_tomembers?.email) ? inqData.assignedmembers[0].assign_tomembers?.email : ' - '}
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Phone</span>
                                                {!isEmpty(inqData.assignedmembers) && !isEmpty(inqData.assignedmembers[0].assign_tomembers?.phone) ? inqData.assignedmembers[0].assign_tomembers?.phone : ' - '}
                                            </p>
                                        </div>
                                        <div className='col-12'>
                                            <p>
                                                <span>Orex ID</span>
                                                {!isEmpty(inqData.assignedmembers) && !isEmpty(inqData.assignedmembers[0].assign_tomembers?.member_unique_number) ? inqData.assignedmembers[0].assign_tomembers?.member_unique_number : ' - '}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Inquiry Information */}
                    <div className='col-xxl-8 col-xl-8 col-lg-8'>
                        <div className='card'>
                            <div className='company-card company-card-info'>
                                <div className='naming-wrape'>
                                    <div className='naming-pad'>
                                        <h3>Inquiry information</h3>
                                    </div>
                                </div>
                                <div className='middle-wrape'>
                                    <div className='row'>
                                        <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                            <p>
                                                <span>Inquiry ID</span>
                                                {inqData.inquiry_unique_id}
                                            </p>
                                        </div>

                                        {inqData.type === 'Supplier' ? (<>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Country</span>
                                                    {!isEmpty(inqData.country) ? inqData.country : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Industry of Work</span>
                                                    {inqData.industry}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Product</span>
                                                    {!isEmpty(inqData.product) ? capitalizeWords(inqData.product) : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Quantity</span>
                                                    {!isEmpty(inqData.quantity) ? inqData.quantity : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Unit</span>
                                                    {!isEmpty(inqData.unit) ? inqData.unit : ' - '}
                                                </p>
                                            </div>
                                        </>) : (<>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Country From</span>
                                                    {!isEmpty(inqData.country_from) ? inqData.country_from : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Country To</span>
                                                    {!isEmpty(inqData.country_to) ? inqData.country_to : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Port of origin</span>
                                                    {!isEmpty(inqData.port_of_origin) ? inqData.port_of_origin : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Port of destination</span>
                                                    {!isEmpty(inqData.port_of_destination) ? inqData.port_of_destination : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Freight type</span>
                                                    {!isEmpty(inqData.freight_type) ? inqData.freight_type : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Length/Width/Height (CM)</span>
                                                    {!isEmpty(inqData.lwh) ? inqData.lwh : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Commodity</span>
                                                    {!isEmpty(inqData.commodity) ? inqData.commodity : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Containers Type/Boxes/Pallat/Packages</span>
                                                    {!isEmpty(inqData.cbpp) ? inqData.cbpp : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Total Weight (KG)</span>
                                                    {!isEmpty(inqData.total_weight) ? inqData.total_weight : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Term</span>
                                                    {!isEmpty(inqData.term) ? inqData.term : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Pickup Address</span>
                                                    {!isEmpty(inqData.pickup_address) ? inqData.pickup_address : ' - '}
                                                </p>
                                            </div>
                                            <div className='col-xxl-4 col-xl-4 col-lg-6'>
                                                <p>
                                                    <span>Delivery Address</span>
                                                    {!isEmpty(inqData.delivery_address) ? inqData.delivery_address : ' - '}
                                                </p>
                                            </div>
                                        </>)}

                                        {!isEmpty(inqData.message) ? (
                                            <div className="col-12">
                                                <div className="naming-wrape">
                                                    <div className="naming-pad"></div>
                                                </div>

                                                <div
                                                    className="border-0"
                                                    dangerouslySetInnerHTML={{
                                                        __html: `<p><span>Message</span> ${inqData.message}</p>`
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="col-12">
                                                <p>
                                                    <span>Message</span> -
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    )

}
const mapStateToProps = state => {
    return {}
}
const mapDispatchToProps = dispatch => {
    return {
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        getMockInq: (id) => dispatch(getMockInquiry(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MockInquiryView);

